import { render, staticRenderFns } from "./MusicForm.vue?vue&type=template&id=f922ba2a&scoped=true&"
import script from "./MusicForm.vue?vue&type=script&lang=js&"
export * from "./MusicForm.vue?vue&type=script&lang=js&"
import style0 from "./MusicForm.vue?vue&type=style&index=0&id=f922ba2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f922ba2a",
  null
  
)

export default component.exports